// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__d9rBP","title":"styles_title__Zqw96","content":"styles_content__N0a_I","buttonWrapper":"styles_buttonWrapper__ufYwq","textLink":"styles_textLink__ozpff"};
module.exports.__checksum = "d175ab862cfb"